import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenVerificationService } from '../../services/token-verification.service';
import { TranslateService } from '@ngx-translate/core';
import { success, warning, error as exception } from 'toastr';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-verify-token',
  templateUrl: './verify-token.component.html',
  styleUrls: ['./verify-token.component.less']
})
export class VerifyTokenComponent implements OnInit {
  private token: string;
  private eventKey: string;
  public message: string;

  constructor(private route: ActivatedRoute,
    private translation: TranslateService,
    private eventService: EventService,
    private tokenVerificationService: TokenVerificationService) {

    this.route.params.subscribe((p) => {
      this.token = p['token'];
      this.eventKey = p['eventKey'];
    });
  }

  ngOnInit() {
    this.loadEvent().then(() => {
      this.checkToken();
    });
  }

  private loadEvent(): Promise<any> {
    return this.eventService.get(this.eventKey)
      .then((result) => { });
  }

  private checkToken() {
    this.setMessage('verify-token.check-token');
    this.tokenVerificationService.Get(this.eventKey, this.token)
      .then((resultGet) => {
        if (resultGet < new Date(Date.now())) {
          this.setMessage('verify-token.token-expired');
          return;
        }
        this.tokenVerificationService.Validate(this.eventKey, this.token).toPromise()
          .then(() => {
            this.setMessage('verify-token.token-processed');
          })
          .catch((reason) => {
            this.setMessage('verify-token.token-validation-failed');
          });
      })
      .catch((reason) => {
        this.setMessage(reason);
      });
  }

  private setMessage(key: string): void {
    this.message = key;
    // this.translation.get(key).subscribe((next) => {
    //   this.message = next;
    // });
  }
}
